import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Sticky from 'Components/Sticky';
import Input from 'Components/Input';
import ModalT1 from 'Components/Common/Modal/ModalT1';
import ConfirmationPopup from 'Components/ConfirmationPopup';
import ActionLoader from 'Components/ActionLoader/index';
import { ReactComponent as BackIcon } from 'Icons/back.svg';
import { ReactComponent as EditIcon } from 'Icons/edit.svg';
import { ReactComponent as DeleteIcon } from 'Icons/delete.svg';
import { ReactComponent as CancelIcon } from 'Icons/cancel.svg';
import { ReactComponent as PlusIcon } from 'Icons/plus.svg';
import { getUser } from 'Utils/storage';
import {
    GET_CITY_MAPPING_DETAILS,
    ADD_CITY_MAPPING_DETAILS,
    UPDATE_CITY_MAPPING_DETAILS,
    DELETE_CITY_MAPPING_DETAILS
} from 'Constants/actionConstants';

class CityMappingMaster extends Component {
    constructor() {
        super();
        this.state = {
            cityMappings: [],
            search: '',
            loading: false,
            error: null,
            isSubmitting: false,
            isModalOpen: false,
            editingId: null,
            formCity: '',
            formAliases: [],
            aliasInput: '',
            formErrors: {},
            isDeletePopupOpen: false,
            deleteTarget: null
        };
    }

    componentDidMount() {
        this.getCityMappings();
    }

    getCityMappings = () => {
        const { dispatch } = this.props;
        const { search } = this.state;
        this.setState({ loading: true, error: null });
        const params = {
            companyId: getUser().companyId
        };
        if (search) {
            params.search = search;
        }
        dispatch({
            type: GET_CITY_MAPPING_DETAILS,
            params,
            onSuccess: (data) => {
                this.setState({ cityMappings: data || [], loading: false });
            },
            onError: (e) => {
                this.setState({
                    loading: false,
                    error: (e && e.message) || 'Failed to load city mappings'
                });
            }
        });
    };

    onSearch = (e) => {
        this.setState({ search: e.target.value }, this.getCityMappings);
    };

    openAddModal = () => {
        this.setState({
            isModalOpen: true,
            editingId: null,
            formCity: '',
            formAliases: [],
            aliasInput: '',
            formErrors: {}
        });
    };

    openEditModal = (record) => {
        this.setState({
            isModalOpen: true,
            editingId: record.city_mapping_id,
            formCity: record.city || '',
            formAliases: [...(record.city_aliases || [])],
            aliasInput: '',
            formErrors: {}
        });
    };

    closeModal = () => {
        this.setState({ isModalOpen: false });
    };

    onChangeCity = (e) => {
        const { formErrors } = this.state;
        this.setState({
            formCity: e.target.value,
            formErrors: { ...formErrors, city: null }
        });
    };

    onChangeAliasInput = (e) => {
        this.setState({ aliasInput: e.target.value });
    };

    addAliasFromInput = () => {
        const { aliasInput, formAliases, formErrors } = this.state;
        const value = aliasInput.trim();
        if (!value) {
            return;
        }
        const alreadyExists = formAliases.some((alias) => alias.toLowerCase() === value.toLowerCase());
        if (alreadyExists) {
            this.setState({ formErrors: { ...formErrors, alias: 'Alias already added' } });
            return;
        }
        this.setState({
            formAliases: [...formAliases, value],
            aliasInput: '',
            formErrors: { ...formErrors, alias: null, aliases: null }
        });
    };

    onAliasInputKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.addAliasFromInput();
        }
    };

    removeAlias = (index) => {
        const { formAliases } = this.state;
        this.setState({
            formAliases: formAliases.filter((_, aliasIndex) => aliasIndex !== index)
        });
    };

    validateForm = () => {
        const { formCity, formAliases } = this.state;
        const errors = {};
        if (!formCity.trim()) {
            errors.city = 'City is required';
        }
        if (formAliases.length === 0) {
            errors.aliases = 'At least one city alias is required';
        }
        this.setState({ formErrors: errors });
        return Object.keys(errors).length === 0;
    };

    handleSubmit = () => {
        if (!this.validateForm()) {
            return;
        }
        const { dispatch } = this.props;
        const { formCity, formAliases, editingId, formErrors } = this.state;
        const payload = {
            company_id: getUser().companyId,
            city: formCity.trim(),
            city_aliases: formAliases
        };
        if (editingId) {
            payload.city_mapping_id = editingId;
        }
        this.setState({ isSubmitting: true });
        dispatch({
            type: editingId ? UPDATE_CITY_MAPPING_DETAILS : ADD_CITY_MAPPING_DETAILS,
            data: payload,
            onSuccess: () => {
                this.setState({ isSubmitting: false });
                this.closeModal();
                this.getCityMappings();
            },
            onError: (e) => {
                this.setState({
                    isSubmitting: false,
                    formErrors: { ...formErrors, submit: (e && e.message) || 'Something went wrong' }
                });
            }
        });
    };

    showDeleteConfirmation = (record) => {
        this.setState({ isDeletePopupOpen: true, deleteTarget: record });
    };

    hideDeleteConfirmation = () => {
        this.setState({ isDeletePopupOpen: false, deleteTarget: null });
    };

    handleDelete = () => {
        const { dispatch } = this.props;
        const { deleteTarget } = this.state;
        this.hideDeleteConfirmation();
        dispatch({
            type: DELETE_CITY_MAPPING_DETAILS,
            data: {
                company_id: getUser().companyId,
                city_mapping_id: deleteTarget.city_mapping_id
            },
            onSuccess: this.getCityMappings
        });
    };

    renderModal() {
        const { isModalOpen, editingId, formCity, formAliases, aliasInput, formErrors, isSubmitting } = this.state;
        return (
            <ModalT1 isOpenState={isModalOpen} handleOnClickForClose={this.closeModal}>
                <div className="city-mapping-modal">
                    <div className="fs-20 fSemibold mb-20">{editingId ? 'Edit City Mapping' : 'Add City Mapping'}</div>
                    <div className="mb-20">
                        <div className="fs-14 fSemibold mb-5">City</div>
                        <Input
                            placeholder="Enter City"
                            name="city"
                            value={formCity}
                            onChange={this.onChangeCity}
                            hasError={!!formErrors.city}
                            errorMessage={formErrors.city}
                            className="col-1"
                        />
                    </div>
                    <div className="mb-20">
                        <div className="fs-14 fSemibold mb-5">City Aliases</div>
                        <div className="flex">
                            <Input
                                placeholder="Type an alias and press Enter"
                                name="aliasInput"
                                value={aliasInput}
                                onChange={this.onChangeAliasInput}
                                onKeyDown={this.onAliasInputKeyDown}
                                className="col-1 mr-10"
                            />
                            <button
                                type="button"
                                className="ht-40 br-20 theme-color border-theme fs-14 fBold pl-20 pr-20"
                                onClick={this.addAliasFromInput}
                            >
                                Add
                            </button>
                        </div>
                        {formErrors.alias && <div className="error-color fs-14 fSemibold mt-5">{formErrors.alias}</div>}
                        {formErrors.aliases && <div className="error-color fs-14 fSemibold mt-5">{formErrors.aliases}</div>}
                        <div className="flex flex-wrap mt-10">
                            {formAliases.map((alias, index) => (
                                <div className="alias-chip flex flex-middle mr-10 mb-10" key={`${alias}-${index}`}>
                                    <span className="fs-14 mr-10">{alias}</span>
                                    <CancelIcon className="wt-12 ht-12 curP" onClick={() => this.removeAlias(index)} />
                                </div>
                            ))}
                        </div>
                    </div>
                    {formErrors.submit && <div className="error-color fs-14 fSemibold mb-10">{formErrors.submit}</div>}
                    <div className="flex flex-center">
                        <button
                            type="button"
                            className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-20"
                            onClick={this.closeModal}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30"
                            disabled={isSubmitting}
                            onClick={this.handleSubmit}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </ModalT1>
        );
    }

    render() {
        const { cityMappings, search, loading, error, isDeletePopupOpen } = this.state;
        return (
            <Sticky>
                {loading && <ActionLoader fixed={true} />}
                <div className="ph-20 pv-20">
                    <div className="pl-20 pr-20 pb-10">
                        <div>
                            <Link className="ht-30 flex flex-middle wt-max-content mb-10 mt-5" to={'/seeker'}>
                                <BackIcon className="mr-10 fill-theme curP fBold" />Back
                            </Link>
                        </div>
                        <div className="flex mt-20 flex-middle flex-between">
                            <div className="text-center fBold fs-24 mb-10 mr-20">City Mapping Master</div>
                            <div className="flex flex-middle">
                                <input
                                    placeholder="Search"
                                    type="text"
                                    className="col-1 br-20 ht-40 bg-gray search mr-10"
                                    name="search"
                                    value={search}
                                    onChange={this.onSearch}
                                />
                                <button
                                    onClick={this.openAddModal}
                                    className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-20 pr-20 flex flex-middle box-shadow"
                                >
                                    <PlusIcon className="wt-14 ht-14 mr-10" />
                                    Add City Mapping
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-20 city-mapping-master">
                    {error && (
                        <div className="tCenter pv-20">
                            <div className="error-color fs-16 fSemibold mb-10">{error}</div>
                            <button
                                className="ht-30 wt-150 br-20 theme-color border-theme fs-14 fBold pl-20 pr-20"
                                onClick={this.getCityMappings}
                            >
                                Retry
                            </button>
                        </div>
                    )}
                    {!error && !loading && (cityMappings || []).length === 0 && (
                        <div className="tCenter pv-20 fs-16 fSemibold">No city mappings found</div>
                    )}
                    {!error && (cityMappings || []).length > 0 && (
                        <table width="100%" border={1}>
                            <thead>
                                <tr>
                                    <th>City</th>
                                    <th>City Aliases</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cityMappings.map((record) => (
                                    <tr key={record.city_mapping_id}>
                                        <td>{record.city}</td>
                                        <td>
                                            <div className="flex flex-wrap flex-center">
                                                {(record.city_aliases || []).map((alias, index) => (
                                                    <div className="alias-chip mr-10 mb-5" key={`${record.city_mapping_id}-${index}`}>
                                                        <span className="fs-14">{alias}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </td>
                                        <td>
                                            <EditIcon
                                                className="wt-20 ht-20 ml-10 curP fBold"
                                                onClick={() => this.openEditModal(record)}
                                            />
                                            <DeleteIcon
                                                className="wt-20 ht-20 ml-10 curP"
                                                onClick={() => this.showDeleteConfirmation(record)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
                {this.renderModal()}
                {isDeletePopupOpen && (
                    <ConfirmationPopup
                        text="Are you sure you want to delete this city mapping"
                        onCancel={this.hideDeleteConfirmation}
                        onConfirm={this.handleDelete}
                    />
                )}
            </Sticky>
        );
    }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(CityMappingMaster);
